module.exports = __webpack_public_path__ + "img/data-order.283ba80f.svg";